import { ChevronDown, Plus } from 'lucide-react';
import type { LiveSummary } from '@multimod/shared';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { MsgAvatar } from './MsgAvatar.js';

interface Props {
  selected: LiveSummary | null;
  onConnect: () => void;
  onLogout: () => void;
}

export function StreamerPill({ selected, onConnect, onLogout }: Props) {
  if (!selected) {
    // #112: empty-state discreto com border-dashed. O halo cyan + border-focus
    // anterior disputava visualmente com o brand "Multimod" (também cyan) ao
    // lado. Tracejado neutro lê como "slot a preencher" sem competir com a marca.
    return (
      <button
        type="button"
        onClick={onConnect}
        className="inline-flex items-center gap-2 h-8 px-3 bg-transparent border border-dashed border-border-strong rounded-md text-sm text-fg-muted hover:text-fg hover:border-fg-subtle hover:bg-bg-muted transition-colors duration-fast focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      >
        <Plus size={14} strokeWidth={1.75} />
        <span>Conectar live</span>
      </button>
    );
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-2 h-8 pl-1.5 pr-2 bg-bg-card border border-border rounded-md text-sm text-fg hover:bg-bg-muted hover:border-border-strong transition-colors duration-fast"
        >
          <MsgAvatar displayName={selected.displayName} externalId={selected.login} />
          <span>{selected.displayName}</span>
          <ChevronDown size={12} strokeWidth={1.75} className="text-fg-muted" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem onClick={onConnect}>Trocar live</DropdownMenuItem>
        <DropdownMenuItem onClick={onLogout}>Sair</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
